import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ParameterService} from "../../_services/parameter.service";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-new-certification-edit',
    templateUrl: './new-certification-edit.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationEditComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    attendanceTypes: any = {};
    associations: any[] = [];
    activities: any[] = [];
    conditionChecked: any[]  = [];
    attendanceChecked: any[] = [];

    providerId: any = null;
    certification: any = null;

    conditions: any[] = [];

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private parameterService: ParameterService,
        private certificationService: NewCertificationService,
        private associationService: AssociationService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            certificationTitle: [null, [Validators.required]],
            ceuRequired: [null, [Validators.required]],
            duration: [null, [Validators.required]],
            durationInMonths: [null, []],
            price: [null, [Validators.required]],
            providerId: [null, [Validators.required]],
            attendanceTypes: [[], []],
            conditions: [[], []]
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.associations = await this.associationService.getAllNoPaging();
        this.certification = await this.certificationService.getById(this.activatedRoute.snapshot.params.certificationId);
        this.activities = await this.associationService.getActivitiesByProviderIdNoPaging(this.certification.association.id);
        this.certification['associationName'] = this.associations.find(r => r.id == this.certification.association.id)?.providerName;

        this.conditions = await this.certificationService.getActivityByCertificationId(this.certification.id);

        this.form.controls.certificationTitle.setValue(this.certification.certificationTitle);
        this.form.controls.providerId.setValue(this.certification.association.id);

            let conditions = this.conditions.map((sp: { id: number; }) => {
                const match = this.activities.find(p => p.id === sp.id);
                return {
                    ...sp,
                    activityType: match ? match.activityType : null,
                };
            });

            console.log(conditions);
            conditions.forEach(r => {
                this.conditionChecked.push({providerActivityId: r.id});
            });

        this.certification.attendanceTypes.forEach((r: { attendanceTypeValue: any; attendanceTypeLabel: any; }) => {
            this.attendanceChecked.push({attendanceTypeValue: r.attendanceTypeValue, attendanceTypeLabel: r.attendanceTypeLabel});
        });

        this.form.controls.attendanceTypes.setValue(this.certification.attendanceTypes);
        this.form.controls.conditions.setValue(this.conditions);
        this.form.controls.ceuRequired.setValue(this.certification.ceuRequired);
        this.form.controls.duration.setValue(this.certification.duration);
        this.form.controls.durationInMonths.setValue(this.certification.durationInMonths);
        this.form.controls.price.setValue(this.certification.price);
    }

    addRemoveActivity($event: any) {
        if($event.checked) {
            if(!this.conditionChecked.find(r => r.providerActivityId == $event.providerActivityId)) {
                this.conditionChecked.push({providerActivityId: $event.providerActivityId});
            }
        } else {
            this.conditionChecked = this.conditionChecked.filter(r => r.providerActivityId != $event.providerActivityId);
        }
        this.form.controls.conditions.setValue(this.conditionChecked);
    }

    addRemoveAttendanceType($event: MatCheckboxChange, attendanceTypeValue: string, attendanceTypeLabel: string) {
        if($event.checked) {
            this.attendanceChecked.push({attendanceTypeValue: attendanceTypeValue, attendanceTypeLabel: attendanceTypeLabel});
        } else {
            this.attendanceChecked = this.attendanceChecked.filter(r => r.attendanceTypeValue != attendanceTypeValue);
        }
        this.form.controls.attendanceTypes.setValue(this.attendanceChecked);
    }

    checkCheckedAttendanceType(attendanceTypeValue: string) {
        let x = this.certification?.attendanceTypes.find((r: { attendanceTypeValue: string; }) => r.attendanceTypeValue == attendanceTypeValue);
        return !!x;

    }

    saveCertification() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Save Certification",
                subMessage: "Are you sure want to update certification?",
                buttonOkLabel: 'Yes, Update',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {

                this.certificationService.updateCertificationInformation(this.form.value, this.certification.id).then(r => {
                    this.showSnackbarDark('Certification', 'Certification has been updated successfully', '');
                    this.router.navigate(['/office/new-certification/detail/' + this.certification.id], {queryParams: {tab: 'detail'}}).then();
                })


            }
        })
    }

    changeDurationInMonths() {
        this.form.controls.durationInMonths.setValue(this.form.controls.duration.value * 12);
    }
}
